import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LockKeyhole, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useApp } from "@/store";

const cls = "w-full rounded-xl border border-gray-200 px-4 py-2.5 outline-none focus:border-[#002FA7] focus:ring-2 focus:ring-[#002FA7]/20";

export default function ResetPassword() {
  const { t } = useApp();
  const navigate = useNavigate();
  const token = new URLSearchParams(useLocation().search).get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { toast.error(t("reset_min")); return; }
    if (pw !== pw2) { toast.error(t("reset_mismatch")); return; }
    setBusy(true);
    try { await api.post("/auth/reset-password", { token, new_password: pw }); toast.success(t("reset_done")); navigate("/login"); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="mx-auto flex max-w-md flex-col px-5 py-16" data-testid="reset-page">
      <div className="flex items-center gap-2 text-[#002FA7]"><LockKeyhole size={22} /><span className="text-xs font-bold uppercase tracking-[0.2em]">{t("reset_title")}</span></div>
      <h1 className="mt-3 font-display text-3xl font-extrabold tracking-tight">{t("reset_title")}</h1>
      {!token ? (
        <div data-testid="reset-no-token" className="mt-6 rounded-2xl bg-[#FF3B30]/10 p-5 text-sm font-semibold text-[#FF3B30]">{t("reset_no_token")} <Link to="/forgot-password" className="underline">{t("forgot_title")}</Link></div>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-3" data-testid="reset-form">
          <input data-testid="reset-password" required type="password" minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} placeholder={t("reset_new")} className={cls} />
          <input data-testid="reset-password2" required type="password" minLength={8} value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder={t("reset_confirm")} className={cls} />
          <button data-testid="reset-submit" disabled={busy} className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#002FA7] py-3 text-sm font-bold text-white disabled:opacity-60">{busy && <Loader2 size={15} className="animate-spin" />} {t("reset_save")}</button>
        </form>
      )}
    </div>
  );
}
